







































































































































































import { Component, Vue, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { OPME, ProtocoloOPME } from '@/types/_'
import _ from 'lodash'

@Component
export default class ComponentAlvoradaSolicitacaoCirurgiaOpme extends Vue {
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: '',
  }

  get protocoloOPMEsApi() {
    return this.getSolicitacaoStore.protocoloOPMEsApi.filter(e => e.protocolo)
  }

  get opmes() {
    return this.getSolicitacaoStore.protocoloOPMEsApi.length
      ? this.getSolicitacaoStore.protocoloOPMEsApi.filter(e => !e.protocolo)
      : []
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get getShowModalOpme() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showOpme
  }

  set getShowModalOpme(value) {
    this.getSolicitacaoStore.showModalOpme(value)
  }

  async setProtocoloOpmeSelected(protocoloOPME: ProtocoloOPME) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)
    await this.getSolicitacaoStore.setProtocoloFornecedorSelected(protocoloOPME)

    if (protocoloOPME.protocolo) {
      await this.getSolicitacaoStore.loadFornecedorProtocoloOPMESelected()
    } else {
      await this.getSolicitacaoStore.loadFornecedores()
    }

    const { protocoloFornecedorOpme }: any = this.$refs
    await protocoloFornecedorOpme.updateFornecedor()

    this.getSolicitacaoStore.setEnableModalProtocoloFornecedor(false)
    this.getSolicitacaoStore.setShowModalOpmeFornecedor(true)
    this.clearLoadingRequest()
  }

  get getProtocoloOPMEs() {
    return this.getSolicitacaoStore.protocoloOPMEs
  }

  get getProtocoloOPMEsApi() {
    return this.getSolicitacaoStore.protocoloOPMEsApi
  }

  nomeFornecedores(fornecedores) {
    let nome: string = ''

    const fornecedoreSort: any[] = fornecedores.filter(c => c.opcao > 0).sort((c1, c2) => {
      if (c1.opcao >= c2.opcao) {
        return 1
      }

      if (c1.opcao <= c2.opcao) {
        return -1
      }

      return 0
    })

    for (let i = 0; i < fornecedoreSort.length; i++) {
      if (fornecedoreSort[i].nome) {
        // eslint-disable-next-line
        nome += `| ${i + 1}° Fornecedor ${fornecedoreSort[i].nome} ${fornecedoreSort[i].fabricante ? ' / ' + fornecedoreSort[i].fabricante : ''}`
      }
    }

    return nome.substring(2, nome.length)
  }

  async addSelected(opme: OPME) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)
    await this.getSolicitacaoStore.postOpme(opme)
    this.getSolicitacaoStore.removeOpmeApi(opme)
    this.loading.listText = 'Todos os itens foram selecionados.'
    this.clearLoadingRequest()
  }

  async addFornecedor() {
    const user = this.$user

    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)

    const medicoId = this.getSolicitacaoStore.isInstrumentador
      ? this.getSolicitacaoStore.solicitacao.medicoSolicitanteId
      : user.profile.sub

    // @ts-ignore
    const opme: OPME = {
      codigo: '',
      id: null,
      justificativa: '',
      historicoMedico: null,
      historicoId: null,
      quantidade: 1,
      termo: this.getInputSearch,
      fornecedores: null,
      agrupamento: null,
      protocolo: false,
      mensagem: '',
      termoMensagem: '',
      medicoId,
    }

    const protocoloOPME: ProtocoloOPME = {
      position: 0,
      protocoloId: '',
      protocolo: false,
      agrupamento: '',
      opmes: [opme],
    }

    this.getSolicitacaoStore.setProtocoloFornecedorSelected(protocoloOPME)
    await this.getSolicitacaoStore.loadFornecedores()
    this.getSolicitacaoStore.setShowModalOpmeFornecedor(true)
    this.getSolicitacaoStore.setEnableModalProtocoloFornecedor(true)
    this.getInputSearch = ''
    this.clearLoadingRequest()
  }

  @Emit('removeOpme')
  removeChip(opme) { }

  debounce = _.debounce(input => this.getSolicitacaoStore.getOpmeSearch(input), 600)

  search(input) {
    if (this.getInputSearch.length === 0 || this.getInputSearch.length > 2) {
      this.debounce(this.getInputSearch)
    }
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }
}

